import { ForegroundColor } from 'chalk';
import LoadingText from '../../../components/LoadingText';
import { CliTestProgress, OsTestProgress } from '../utilities/build';
import ProgressBar from './ProgressBar';

export default function TestProgress({
  progress,
}: {
  progress?: CliTestProgress;
}) {
  if (!progress) {
    return <LoadingText text="Loading test stats" />;
  }

  return (
    <>
      {!progress.windows.shouldSkip && (
        <OsProgress os="Windows" progress={progress.windows} />
      )}
      {!progress.mac.shouldSkip && (
        <OsProgress os="macOS" progress={progress.mac} />
      )}
      {!progress.linux.shouldSkip && (
        <OsProgress os="Linux" progress={progress.linux} />
      )}
    </>
  );
}

function OsProgress({
  os,
  progress,
}: {
  os: string;
  progress: OsTestProgress;
}) {
  const colors: Record<OsTestProgress['state'], typeof ForegroundColor> = {
    progress: 'white',
    error: 'red',
    done: 'green',
    skipped: 'yellow', // Not used actually, just for type matching
  };
  const text = progress.message + (progress.state === 'progress' ? '...' : '');

  return (
    <ProgressBar
      color={colors[progress.state]}
      label={os}
      progress={progress.progress}
      text={text}
    />
  );
}
